import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  objectiveValuesLength: 0,
  objectiveValues: [],
  objectiveValue: {},
  objectiveValueError: "",
  formError: "",
};

export default function ObjectiveValueReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_VALUE:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_VALUE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OBJECTIVE_VALUE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OBJECTIVE_VALUE:
      return {
        ...state,
        objectiveValues: action.payload.objectiveValues,
        objectiveValuesLength: action.payload.objectiveValuesLength,
      };
    case actions.GET_OBJECTIVE_VALUE_BY_ID:
      return {
        ...state, objectiveValue: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OBJECTIVE_VALUE_FAIL:
      return { ...state, objectiveValueError: action.payload };
    default:
      return state;
  }
}
